export default function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}



// WEBPACK FOOTER //
// ../src/core/translate/maxTranslate.js